import { render, staticRenderFns } from "./GlobalEditorSettings.vue?vue&type=template&id=5ff913ca&scoped=true&"
import script from "./GlobalEditorSettings.vue?vue&type=script&lang=js&"
export * from "./GlobalEditorSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff913ca",
  null
  
)

export default component.exports